// extracted by mini-css-extract-plugin
module.exports = {"cashInsurance":"insuranceHome-module--cash-Insurance--2jMbZ","unorderlist":"insuranceHome-module--unorderlist--3NjOh"};